/* 🤖 this file was generated by svg-to-ts */
export const matIconWifiProtectedSetup: {
  name: 'wifi-protected-setup';
  data: string;
} = {
  name: 'wifi-protected-setup',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16.71 5.29 19 3h-8v8l2.3-2.3c1.97 1.46 3.25 3.78 3.25 6.42 0 1.31-.32 2.54-.88 3.63 2.33-1.52 3.88-4.14 3.88-7.13 0-2.52-1.11-4.77-2.84-6.33z"/><path d="M7.46 8.88c0-1.31.32-2.54.88-3.63a8.479 8.479 0 0 0-3.88 7.13c0 2.52 1.1 4.77 2.84 6.33L5 21h8v-8l-2.3 2.3c-1.96-1.46-3.24-3.78-3.24-6.42z"/></svg>`
};
